module.exports = __webpack_public_path__ + "img/e.6b617a3d.jpg";